<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span>Update password</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Old Password" required>
              <a-input-password
                v-model.trim="$v.formData.old_password.$model"
              />
              <div v-if="$v.formData.old_password.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.old_password.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="New Password" required>
              <a-input-password v-model.trim="$v.formData.password.$model" />
              <div v-if="$v.formData.password.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.password.required">
                  Field is required
                </div>
                <div class="error" v-if="!$v.formData.password.minLength">
                  Password must be at least 8 characters long
                </div>
                <div
                  class="error"
                  v-if="!$v.formData.password.containsUppercase"
                >
                  Password must contain at least one uppercase letter
                </div>
                <div
                  class="error"
                  v-if="!$v.formData.password.containsLowercase"
                >
                  Password must contain at least one lowercase letter
                </div>
                <div class="error" v-if="!$v.formData.password.containsNumber">
                  Password must contain at least one number
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Repeat Password" required>
              <a-input-password
                v-model.trim="$v.formData.repeat_password.$model"
              />
              <div
                v-if="$v.formData.repeat_password.$dirty"
                class="text-danger"
              >
                <div class="error" v-if="!$v.formData.repeat_password.required">
                  Field is required
                </div>
                <div
                  class="error"
                  v-if="!$v.formData.repeat_password.sameAsPassword"
                >
                  Passwords do not match
                </div>
              </div>
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <div>
                    <b-button
                      size="sm"
                      variant="primary"
                      @click.prevent="confirmUpdatePassword"
                    >
                      OK
                    </b-button>
                  </div>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '../../controllers/secureStorage';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { Modal } from 'ant-design-vue';
export default {
  name: 'PasswordUpdateForm',
  data() {
    return {
      formSubmitting: false,
      currentSiteId: secureStorage.getItem('currentSiteId'),
      source: secureStorage.getItem('source'),
      formData: {
        old_password: null,
        password: null,
        repeat_password: null
      }
    };
  },
  validations: {
    formData: {
      old_password: { required },
      password: {
        required,
        minLength: minLength(8),
        containsUppercase: (value) => /[A-Z]/.test(value),
        containsLowercase: (value) => /[a-z]/.test(value),
        containsNumber: (value) => /\d/.test(value)
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs(function () {
          return this.formData.password;
        })
      }
    }
  },
  methods: {
    confirmUpdatePassword() {
      Modal.confirm({
        title: 'Confirm',
        content: 'Are you sure you want to change your password?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => {
          this.updatePassword();
        }
      });
    },
    async updatePassword() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest(
          '/api/v1/users/update_password?&source=' + this.source,
          {
            update_password: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Password has been changed.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      }
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },

    clearForm() {
      this.formData = {
        old_password: null,
        password: null,
        repeat_password: null
      };
    }
  },
  created() {
    this.$store.dispatch('setCurrentModule', 'Password Update');
  }
};
</script>

<style scoped></style>
